<template>
  <el-dialog
    :visible="dialogVisible"
    width="600px"
    :before-close="close"
    :close-on-click-modal="false"
    :title="title"
    class="customDialogForm"
  >
    <el-form ref="packageform" :rules="rules" :model="appPackage">
      <el-form-item prop="name" label="名称" :label-width="formLabelWidth">
        <el-input
          v-model="appPackage.name"
          placeholder="请输入套餐名称"
        ></el-input>
      </el-form-item>
      <!-- 套餐类型 -->
      <el-form-item label="套餐类型" :label-width="formLabelWidth">
        <el-select
          v-model="packageType"
          placeholder="请选择套餐类型"
          :disabled="appPackage.packageID != undefined"
        >
          <el-option
            v-for="item in packageList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div v-if="packageType !== 'business'">
        <!-- 商品套餐需要先选择模板 -->
        <el-form-item
          v-if="isProductPackage"
          prop="appKeyID"
          label="选择模板"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="selectedTemplate"
            @change="handleTemplateChange"
            placeholder="请先选择应用模板"
            filterable
          >
            <el-option
              v-for="item in templateList"
              :key="item.appKeyID"
              :label="item.name"
              :value="item.appKeyID"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="version" label="版本" :label-width="formLabelWidth">
          <div>
          <el-select
            @change="versionChange"
            v-model="appPackage.version"
            placeholder="选择应用版本"
            :disabled="isProductPackage && !selectedTemplate"
          >
            <el-option
              v-for="item in availableVersions"
              :key="item.appVersion"
              :label="showVersionName(item)"
              :value="item.appVersion"
              v-show="item.templateType == 'RAM'"
            >
            {{showVersionName(item)}}
            <template>
              <el-tag
                v-show="item.arch != '' "
                key="amd64"
                type=""
                effect="dark"
              >
                {{ item.arch }}
              </el-tag>
            </template>
            </el-option>
          </el-select>
          </div>
        </el-form-item>
      </div>
      <el-form-item
        prop="enable"
        label="启用状态"
        :label-width="formLabelWidth"
      >
        <el-switch
          v-model="appPackage.enable"
          active-color="#13ce66"
          inactive-color="#ff4949"
        ></el-switch>
      </el-form-item>
      <div v-if="packageType === 'pay'">
        <!-- 计费方式 -->
        <el-form-item
          prop="billtype"
          label="计费方式"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.billtype"
            placeholder="选择应用计费方式"
          >
            <el-option
              v-for="item in billtypes"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 计费周期 -->
        <el-form-item
          prop="billCycle"
          label="计费周期"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.billCycle"
            placeholder="选择计费基础周期"
          >
            <el-option
              v-for="item in billCycles"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 周期单价 -->
        <el-form-item
          prop="price"
          label="周期单价"
          :label-width="formLabelWidth"
        >
          <el-input
            type="number"
            :min="0"
            :max="2147483647"
            v-model="appPackage.price"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </div>
      <div v-if="packageType !== 'business'">
        <!-- 交付环境 -->
        <el-form-item
          v-if="regionSelect"
          prop="deliveryRegionID"
          label="交付环境"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="appPackage.deliveryRegionID"
            placeholder="选择该套餐默认的交付环境"
          >
            <el-option-group
              v-for="group in deliveryRegions"
              :key="group.label"
              :label="group.label"
            >
              <el-option
                v-for="item in group.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-option-group>
          </el-select>
        </el-form-item>
        <!-- 交付审核 -->
        <el-form-item
          prop="enableReview"
          label="交付审核"
          :label-width="formLabelWidth"
        >
          <el-switch
            v-model="appPackage.enableReview"
            active-color="#13ce66"
            inactive-color="#ff4949"
          ></el-switch>
        </el-form-item>
        <!-- 支持试用和试用天数 -->
        <el-row v-if="packageType === 'pay'">
          <el-col :span="12">
            <el-form-item
              prop="supportTrial"
              label="支持试用"
              :label-width="formLabelWidth"
            >
              <el-switch
                @change="changeSupportTrial"
                v-model="appPackage.supportTrial"
                active-color="#13ce66"
                inactive-color="#ff4949"
              ></el-switch>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              v-if="appPackage.supportTrial"
              prop="trialDays"
              label="试用天数"
              :label-width="formLabelWidth"
            >
              <el-input-number
                v-model="appPackage.trialDays"
                :min="1"
                :max="7"
                placeholder="请输入试用天数(1-7)"
              ></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="套餐指标" :label-width="formLabelWidth">
          <el-row
            v-for="(item, index) in appPackage.items"
            :key="index"
            :style="{
              marginTop: index === 0 ? '' : '20px'
            }"
          >
            <el-col :span="8">
              <el-form-item
                :prop="`items[${index}].showName`"
                :rules="rules.showNames"
                :label="index === 0 ? '指标名称' : ''"
                :label-width="formLabelWidth"
                class="clearMt"
              >
                <el-input
                  type="text"
                  placeholder="请输入指标名称"
                  v-model="item.showName"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :prop="`items[${index}].name`"
                :label="index === 0 ? '标识' : ''"
                :label-width="formLabelWidth"
                :rules="rules.tags"
                class="clearMt"
              >
                <el-input
                  type="text"
                  v-model="item.name"
                  placeholder="请输入标识"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item
                :prop="`items[${index}].value`"
                :label="index === 0 ? '值' : ''"
                :label-width="formLabelWidth"
                :rules="rules.values"
                class="clearMt clearPd"
              >
                <el-input
                  placeholder="值"
                  v-model="item.value"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col
              :span="3"
              class="operationIcon"
              :style="{
                marginTop: index === 0 ? '50px' : '13px'
              }"
            >
              <i
                style="font-size: 20px"
                class="el-icon-circle-plus-outline"
                @click="handleAddPackageIndicators"
              ></i>
              <i
                style="font-size: 20px"
                class="el-icon-remove-outline"
                v-show="index !== 0"
                @click="handleDeletePackageIndicators(index)"
              ></i>
            </el-col>
          </el-row>
        </el-form-item>
      </div>

      <el-form-item
        prop="description"
        label="描述"
        :label-width="formLabelWidth"
      >
        <el-input
          type="textarea"
          v-model="appPackage.description"
          autocomplete="off"
        ></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="close">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>
<script>
import { createAppPackage, updateAppPackage, fetchAppVersions } from '@/api/app';
import { createProductPackage, updateProductPackage } from '@/api/product';
import { fetchDeliveryRegionList } from '@/api/delivery';
import { handleRegion } from '@/utils/common';
import { errorHandle } from '@/utils/error';

export default {
  name: 'EditAppPackage',
  props: {
    versions: {
      type: Array
    },
    appPackage: {
      type: Object
    },
    appID: String,
    productID: String, // 添加商品ID支持
    marketID: String,
    dialogVisible: Boolean,
    onClose: Function,
    onSuccess: Function
  },
  data() {
    const validateItems = (rule, value, callback) => {
      const arr = this.appPackage.items;
      if (arr) {
        arr.map((item, index) => {
          const { name, showName, value } = item;
          if (
            name ||
            showName ||
            value ||
            (index !== 0 && (!name || !showName || !value))
          ) {
            if (!name && rule.field == `items[${index}].name`) {
              callback(new Error('请输入标识'));
            }
            if (!showName && rule.field == `items[${index}].showName`) {
              callback(new Error(' 请输入指标名称'));
            }
            if (!value && rule.field == `items[${index}].value`) {
              callback(new Error('请输入值'));
            }
          }
        });
        callback();
      } else {
        callback();
      }
    };
    return {
      regionSelect: true,
      templateList: [], // 模板列表
      versionList: [], // 版本列表(基于选择的模板)
      selectedTemplate: '', // 选中的模板ID
      billtypes: [
        {
          label: '按时间计费',
          value: 'time'
        }
      ],
      billCycles: [
        {
          label: '周',
          value: 'week'
        },
        {
          label: '月度',
          value: 'month'
        },
        {
          label: '季度',
          value: 'quarter'
        },
        {
          label: '年度',
          value: 'year'
        }
      ],
      deliveryRegions: [],
      rules: {
        enable: {
          required: true,
          message: '启用状态必须指定',
          trigger: 'change'
        },
        name: [
          { required: true, message: '请输入套餐名称', trigger: 'change' },
          { max: 32, message: '套餐名称最多32个字符', trigger: 'change' }
        ],
        version: [
          { required: true, message: '请选择关联版本', trigger: 'change' }
        ],
        billtype: [
          { required: true, message: '请选择计费类型', trigger: 'change' }
        ],
        billCycle: [
          { required: true, message: '请选择基础计费周期', trigger: 'change' }
        ],
        price: [
          { required: true, message: '请输入套餐周期单价', trigger: 'change' },
          {
            validator(rule, value, callback) {
              if (/(^[0-9]\d*$)/.test(value)) {
                if (value > 2147483647) {
                  callback('最大单价是2147483647');
                } else if (value < 0) {
                  callback('最小单价是0');
                } else {
                  callback();
                }
              } else {
                callback(new Error('请输入正整数'));
              }
            },
            trigger: 'change'
          }
        ],
        description: [
          { min: 2, max: 255, message: '描述最多255个字符', trigger: 'change' }
        ],
        trialDays: [
          {
            validator(rule, value, callback) {
              if (this.appPackage && this.appPackage.supportTrial) {
                if (!value) {
                  callback(new Error('支持试用时,试用天数必填'));
                } else if (value < 1 || value > 7) {
                  callback(new Error('试用天数范围为1-7天'));
                } else {
                  callback();
                }
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ],
        showNames: [
          { required: false, message: '请输入指标名称', trigger: 'change' },
          { validator: validateItems, trigger: 'change' }
        ],
        tags: [
          { required: false, message: '请输入标识', trigger: 'change' },
          { validator: validateItems, trigger: 'change' }
        ],
        values: [
          {
            required: false,

            message: '请输入值',
            trigger: 'change'
          },
          { validator: validateItems, trigger: 'change' }
        ]
      },
      app: {},
      title: this.appPackage.packageID != undefined ? '编辑套餐' : '新增套餐',
      formLabelWidth: '100px',
      Loading: false,
      packageList: [
        { id: 'free', name: '免费' },
        { id: 'pay', name: '付费' },
        { id: 'business', name: '商业咨询' }
      ],
      packageType:
        this.appPackage.packageID != undefined
          ? this.appPackage.packageType
          : 'free'
    };
  },
  created() {
    this.fetchRegions();
    // 如果是商品套餐,需要加载模板列表
    if (this.productID) {
      this.fetchTemplateList();
      // 如果是编辑模式且已有appKeyID,加载对应的版本列表
      if (this.appPackage.appKeyID) {
        this.selectedTemplate = this.appPackage.appKeyID;
        this.fetchVersionsByTemplate(this.appPackage.appKeyID);
      }
    }
  },
  mounted() {
  },
  computed: {
    // 判断是商品套餐还是应用套餐
    isProductPackage() {
      return !!this.productID;
    },
    // 获取可用的版本列表
    availableVersions() {
      return this.isProductPackage ? this.versionList : (this.versions || []);
    }
  },
  methods: {
    // 获取模板列表
    fetchTemplateList() {
      this.$store
        .dispatch('GetStoreAppManageList', {
          marketID: this.marketID,
          page: 1,
          pageSize: 999
        })
        .then((res) => {
          if (res && res.apps) {
            this.templateList = res.apps;
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    // 根据选择的模板获取版本列表
    fetchVersionsByTemplate(appKeyID) {
      if (!appKeyID) {
        this.versionList = [];
        this.appPackage.version = '';
        return;
      }
      fetchAppVersions({ marketID: this.marketID, appID: appKeyID })
        .then((res) => {
          this.versionList = res.versions || [];
        })
        .catch((err) => {
          errorHandle(err);
          this.versionList = [];
        });
    },
    // 模板选择变化处理
    handleTemplateChange(appKeyID) {
      this.appPackage.appKeyID = appKeyID;
      this.appPackage.version = ''; // 清空版本选择
      this.fetchVersionsByTemplate(appKeyID);
    },
    versionChange(v) {
      let saas = false;
      const versionList = this.availableVersions || [];
      versionList.map((version) => {
        if (version.appVersion == v && version.deliveryMode == 'saas') {
          saas = true;
        }
      });
      this.regionSelect = !saas;
    },
    handleAddPackageIndicators() {
      this.appPackage.items = [
        ...this.appPackage.items,
        ...[{ name: '', showName: '', value: '' }]
      ];
    },
    handleDeletePackageIndicators(index) {
      this.appPackage.items.splice(index, 1);
    },
    changeSupportTrial(value) {
      if (!value) {
        // 当关闭支持试用时,清空试用天数
        this.appPackage.trialDays = undefined;
      } else {
        // 当开启支持试用时,设置默认试用天数为7天
        if (!this.appPackage.trialDays) {
          this.appPackage.trialDays = 7;
        }
      }
    },
    showVersionName(version) {
      if (version.appVersionAlias) {
        return `${version.appVersion}(${version.appVersionAlias})`;
      }
      return version.appVersion;
    },
    fetchRegions() {
      fetchDeliveryRegionList({
        marketID: this.marketID,
        page: -1,
        pageSize: -1
      })
        .then((res) => {
          if (res) {
            if (res.regions) {
              this.deliveryRegions = handleRegion(res.regions);
            } else {
              this.deliveryRegions = [];
            }
          }
        })
        .catch((err) => {
          errorHandle(err);
        });
    },
    submit() {
      this.Loading = true;
      this.$refs.packageform.validate((valid) => {
        if (valid) {
          this.appPackage.marketID = this.marketID;
          this.appPackage.price = Number(this.appPackage.price);
          this.appPackage.packageType = this.packageType;
          this.appPackage.templateType = this.appPackage.templateType || 'rainbond';

          // 商品套餐需要设置 appKeyID,应用套餐需要设置 appID
          if (this.isProductPackage) {
            this.appPackage.productID = this.productID;
            // appKeyID 已经在 handleTemplateChange 中设置
          } else {
            this.appPackage.appID = this.appID;
          }

          const obj = Object.assign({}, this.appPackage);
          let isItems;
          if (obj.items.length >= 1) {
            obj.items.map((item) => {
              const { name, showName, value } = item;
              if (name || showName || value) {
                isItems = true;
              }
            });
          }
          obj.items = isItems ? this.appPackage.items : undefined;

          // 处理试用相关字段：当 supportTrial 为 false 时，移除 trialDays
          if (!obj.supportTrial) {
            delete obj.trialDays;
          }

          // 根据是否是商品套餐选择对应的API
          const createPackageAPI = this.isProductPackage ? createProductPackage : createAppPackage;
          const updatePackageAPI = this.isProductPackage ? updateProductPackage : updateAppPackage;

          if (!this.appPackage.packageID) {
            createPackageAPI(obj)
              .then((res) => {
                this.Loading = false;
                this.$message.success('套餐创建成功');
                this.onSuccess && this.onSuccess();
                this.reset();
              })
              .catch((err) => {
                this.Loading = false;
                errorHandle(err);
              });
          } else {
            if (obj.packageType && obj.packageType === 'free') {
              obj.billCycle = 'year';
              obj.billtype = 'time';
            } else if (obj.packageType && obj.packageType === 'business') {
              obj.billCycle = '';
              obj.billtype = '';
            }
            updatePackageAPI(obj)
              .then((res) => {
                this.Loading = false;
                this.$message.success('套餐更新成功');
                this.onSuccess && this.onSuccess();
                this.reset();
              })
              .catch((err) => {
                this.Loading = false;
                errorHandle(err);
              });
          }
        } else {
          this.Loading = false;
        }
      });
    },
    close() {
      this.$refs.packageform.resetFields();
      this.onClose && this.onClose();
    },
    reset() {
      this.$refs.packageform.resetFields();
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
::v-deep .clearMt {
  .el-form-item__label {
    text-align: left;
  }
  .el-form-item__content {
    margin-left: 0 !important;
  }
  .el-input {
    width: 96%;
  }
}
::v-deep .clearPd {
  .el-input__inner {
    padding: 0 0 0 5px;
  }
}

.operationIcon {
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}
</style>



// WEBPACK FOOTER //
// src/views/storeManage/productManage/components/editAppPackage.vue